const state = {
  cat: {},
  cats: [],
  trashedData: [],
}
export default state
